import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import SchedulerProps from './SchedulerProps'
import KendoSchedulerResource from '../KendoSchedulerResource'
import KendoSchedulerView from '../KendoSchedulerView'

import CurrentTimeMarker from './CurrentTimeMarker'
import Editable from './Editable'
import Footer from './Footer'
import Group from './Group'
import Messages from './Messages'
import Pdf from './Pdf'
import Toolbar from './Toolbar'

export default {
    props: SchedulerProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        CurrentTimeMarker,
        Editable,
        Footer,
        Group,
        Messages,
        Pdf,
        Toolbar
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoScheduler(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoScheduler()
        },
        _resolveChildren() {
            this.resolveChildren('resources', KendoSchedulerResource.name)
            this.resolveChildren('views', KendoSchedulerView.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/KendoSchedulerMixin.js